import axios from 'axios'

import { IAuthInfoResponse } from './types'

/**
 * The address-to-account lookup, with no side effects: it opens no modals and touches no
 * state, so the caller decides what its answer means.
 */
export const fetchAuthInfo = async (email: string): Promise<IAuthInfoResponse> => {
  const response = await axios.post<IAuthInfoResponse>(`${process.env.REACT_APP_API_URL}/core/auth-lookup`, { email })
  return response.data
}
